import { useVisibleAxesConfig } from './useVisibleAxesConfig.js';
import { useVisibleAxesScales } from './useVisibleAxesScales.js';
import type { DateScales } from '../../core/types/scales.js';
import { isTimeAxis } from '../types/guards.js';

export function useSyncedXScaleByPriority() {
  const axesScale = useVisibleAxesScales();
  const axesConfig = useVisibleAxesConfig();

  if (axesConfig.bottom && isTimeAxis(axesConfig.bottom)) {
    return axesScale.bottom as DateScales;
  }

  if (axesConfig.top && isTimeAxis(axesConfig.top)) {
    return axesScale.top as DateScales;
  }
}
